import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;
const PENGAJUAN_ENDPOINT = "/pengajuan"; 

const getAuthToken = () => Cookies.get('access_token');

// Header untuk request JSON biasa
const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`,
  'Content-Type': 'application/json',
});

// Header untuk FormData (JANGAN set Content-Type, biarkan axios + browser yang atur boundary)
const getAuthHeadersMultipart = () => ({
  'Authorization': `Bearer ${getAuthToken()}`,
});

// --- 1. GET ALL PENGAJUAN (History & Monitoring) ---
export const fetchPengajuans = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams();
    
    if (params.disable_pagination) {
        urlParams.append('disable_pagination', 'true');
    } else {
        urlParams.append('page', params.page || 1);
        urlParams.append('per_page', params.per_page || 10);
    }
    
    if (params.search) urlParams.append('search', params.search);
    if (params.status_pengajuan) urlParams.append('status_pengajuan', params.status_pengajuan);
    if (params.tipe_transaksi) urlParams.append('tipe_transaksi', params.tipe_transaksi);
    if (params.id_lokasi) urlParams.append('id_lokasi', params.id_lokasi);
    if (params.id_blok) urlParams.append('id_blok', params.id_blok);
    if (params.id_divisi) urlParams.append('id_divisi', params.id_divisi);
    if (params.id_wilayah) urlParams.append('id_wilayah', params.id_wilayah);
    if (params.tipe_pengajuan) urlParams.append('tipe_pengajuan', params.tipe_pengajuan);
    if (params.start_date) urlParams.append('start_date', params.start_date);
    if (params.end_date) urlParams.append('end_date', params.end_date);
    
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}?${urlParams.toString()}`, {
      headers: getAuthHeaders()
    });
    
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message; 
  }
};

// --- 2. GET INBOX APPROVAL (Tugas Pimpinan) ---
export const fetchInbox = async (params = {}) => {
  try {
    const urlParams = new URLSearchParams();

    urlParams.append('page', params.page || 1);
    urlParams.append('per_page', params.per_page || 10);

    if (params.search) urlParams.append('search', params.search);
    if (params.tipe_pengajuan) urlParams.append('tipe_pengajuan', params.tipe_pengajuan);
    if (params.id_divisi) urlParams.append('id_divisi', params.id_divisi);
    if (params.id_wilayah) urlParams.append('id_wilayah', params.id_wilayah);
    if (params.id_lokasi) urlParams.append('id_lokasi', params.id_lokasi);
    if (params.start_date) urlParams.append('start_date', params.start_date);
    if (params.end_date) urlParams.append('end_date', params.end_date);

    const response = await axios.get(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/inbox?${urlParams.toString()}`,
      { headers: getAuthHeaders() }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 3. GET PENGAJUAN BY ID ---
export const getPengajuanByID = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 4. CREATE PENGAJUAN ---
export const createPengajuan = async (payload) => {
  try {
    const isFormData = payload instanceof FormData;

    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}`,
      payload,
      {
        headers: isFormData ? getAuthHeadersMultipart() : getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 5. UPDATE PENGAJUAN ---
export const updatePengajuan = async (id_pengajuan, payload) => {
  try {
    const isFormData = payload instanceof FormData;

    const response = await axios.put(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}`,
      payload,
      {
        headers: isFormData ? getAuthHeadersMultipart() : getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateFinanceChecklist = async (id_pengajuan, payload) => {
  try {
    const response = await axios.patch(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}/finance-checklist`,
      payload,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 6. DELETE PENGAJUAN ---
export const deletePengajuan = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 7. WORKFLOW: APPROVE ---
export const approvePengajuan = async (id_pengajuan, catatan = "") => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}/approve`,
      { catatan },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 8. WORKFLOW: REJECT ---
export const rejectPengajuan = async (id_pengajuan, catatan = "") => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}/reject`,
      { catatan },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const revisiPengajuan = async (id_pengajuan, catatan = "") => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}/revisi`,
      { catatan },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// --- 9. WORKFLOW: CAIRKAN (DISBURSEMENT) ---
export const cairkanPengajuan = async (id_pengajuan, formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/${id_pengajuan}/cairkan`,
      formData,
      {
        headers: getAuthHeadersMultipart(), // penting: biarkan axios atur Content-Type
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ====================== LAPORAN ======================

export const getNeraca = async (startDate, endDate) => {
  try {
    const params = {
      start_date: startDate,
      end_date: endDate
    };

    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/neraca`, {
      headers: getAuthHeaders(),
      params
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLabaRugi = async (startDate, endDate) => {
  try {
    const params = {
      start_date: startDate,
      end_date: endDate
    };

    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/laba-rugi`, {
      headers: getAuthHeaders(),
      params
    });
    
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCashFlow = async (startDate, endDate, idDivisi, idWilayah, idCoa, idLokasi) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/cash-flow`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate,
        id_divisi: idDivisi || undefined,
        id_wilayah: idWilayah || undefined,
        id_coa: idCoa || undefined,
        id_lokasi: idLokasi || undefined,
        disable_pagination: true
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getRincianPemasukanPengeluaran = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/rincian-pemasukan-pengeluaran`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanArusKasBank = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/arus-kas-bank`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanPiutangKaryawan = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/piutang-karyawan`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getSaldoPiutangKaryawan = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/saldo-piutang-karyawan/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getSaldoPiutangPihakKetiga = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/saldo-piutang-pk/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanPiutangPihakKetiga = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/piutang-pihak-ketiga`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanArusKasBlokir = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/kas-bank-blokir`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanArusKasTunai = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/arus-kas-tunai`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Filter bank & lokasi bersifat opsional -- hanya dikirim kalau dipilih,
// supaya backend tidak menerima nilai kosong yang bisa terbaca sebagai
// filter bernilai 0.
export const getLaporanHutangBank = async ({ id_bank, id_lokasi } = {}) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/hutang-bank`, {
      headers: getAuthHeaders(),
      params: {
        ...(id_bank ? { id_bank } : {}),
        ...(id_lokasi ? { id_lokasi } : {})
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanHutangTanah = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/hutang-tanah`, {
      headers: getAuthHeaders(),
      params: {
        id_lokasi: params.id_lokasi || 0,
        kode_transaksi: params.kode_transaksi || "", 
        search: params.search || "",
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error getLaporanHutangTanah:", error);
    throw error.response?.data || error.message;
  }
};

export const getLaporanHutangMandor = async (
  id_lokasi = null, 
  id_mandor = null, 
  id_wilayah = null, 
  id_pembangunan = null
) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/hutang-mandor`, {
      headers: getAuthHeaders(),
      params: {
        id_lokasi,
        id_mandor,
        id_wilayah,
        id_pembangunan
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanSisaPersediaanTanah = async (startDate, endDate, idLokasi, idBlok) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/persediaan-tanah`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate,
        id_lokasi: idLokasi,
        nama_blok: idBlok
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanSisaPersediaanBangunan = async (startDate, endDate, idLokasi, idBlok) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/persediaan-bangunan`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate,
        id_lokasi: idLokasi,
        nama_blok: idBlok
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanDeposito = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/deposito`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanTanahBangunan = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/tanah-bangunan`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanKendaraan = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/kendaraan`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanInventarisKantor = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/inventaris-kantor`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getLaporanDajam = async (startDate, endDate) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/dajam`, {
      headers: getAuthHeaders(),
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const saveBankReconciliation = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${PENGAJUAN_ENDPOINT}/bank-reconciliation`, 
      payload,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error saveBankReconciliation:", error);
    throw error.response?.data || error.message;
  }
};